import { useMemo } from "react";
import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { Tables, SummaryTableDepths, hashCode } from "@repo/utils";
import { ELEMENT_TYPES } from "@utils";
import {
  useEstimateStructure,
  useEstimateEditorSettings,
  Row,
  RowGroup,
  ExpandContainer,
  useVisibilityModeCellClassName
} from "@tools";
import { ColumnFactory } from "./ColumnFactory";
import { TitleCell } from "./cells";

export const SummaryNestedRow = observer(({
  resource,
  isLastGroupRow,
  turnOff,
}) => {
  const { workTypesHaveResources } = useEstimateStructure();
  const { allowEdition, isProposal } = useEstimateEditorSettings();

  const { treePath, isHidden } = resource;

  const className = useVisibilityModeCellClassName(isHidden);

  const tableDepth = SummaryTableDepths.TEAM_MEMBER;

  const hashedPath = useMemo(() => (
    [Tables.SUMMARY, ...treePath].map((id) => hashCode(id))
  ), [treePath]);

  return (
    <RowGroup
      tableDepth={tableDepth}
      isStatic//={!allowEdition}
      hashedPath={hashedPath}
      elementType={ELEMENT_TYPES.RESOURCE}
      className={className}
    >
      <Row
        useDragHandleCell={allowEdition}
        isLastGroupRow={isLastGroupRow}
        tableDepth={tableDepth}
        visible={!turnOff}
        presetClass="preset-rowSummary"
        actionPresetClass="preset-paper"
      >
        <TitleCell resource={resource}>
          <ExpandContainer
            tableDepth={tableDepth}
            useExpandCell={!isProposal || workTypesHaveResources}
          />
        </TitleCell>
        <ColumnFactory element={resource} />
      </Row>
    </RowGroup>
  );
});

SummaryNestedRow.propTypes = {
  resource: object.isRequired,
  isLastGroupRow: bool,
  turnOff: bool,
};
